import type { InputAdapter, InputFrame } from './types'
import { EMPTY_INPUT } from './types'

/** Состояние, которое HUD mobile-контролов пишет каждый кадр */
export interface MobileControlState {
  move: { x: number; y: number }
  lookDelta: { x: number; y: number }
  defuseHold: boolean
  /** Rising edge через sample, как pause */
  check: boolean
  pause: boolean
  cameraToggle: boolean
}

export class MobileAdapter implements InputAdapter {
  private enabled = false
  state: MobileControlState = {
    move: { x: 0, y: 0 },
    lookDelta: { x: 0, y: 0 },
    defuseHold: false,
    check: false,
    pause: false,
    cameraToggle: false,
  }

  private pauseEdge = false
  private cameraToggleEdge = false
  private checkEdge = false
  private prevPause = false
  private prevCameraToggle = false
  private prevCheck = false

  setEnabled(enabled: boolean): void {
    this.enabled = enabled
    if (!enabled) {
      this.state = {
        move: { x: 0, y: 0 },
        lookDelta: { x: 0, y: 0 },
        defuseHold: false,
        check: false,
        pause: false,
        cameraToggle: false,
      }
      this.prevPause = false
      this.prevCameraToggle = false
      this.prevCheck = false
    }
  }

  sample(_dt: number): InputFrame {
    if (!this.enabled) return { ...EMPTY_INPUT }

    this.pauseEdge = this.state.pause && !this.prevPause
    this.cameraToggleEdge = this.state.cameraToggle && !this.prevCameraToggle
    this.checkEdge = this.state.check && !this.prevCheck
    this.prevPause = this.state.pause
    this.prevCameraToggle = this.state.cameraToggle
    this.prevCheck = this.state.check

    const frame: InputFrame = {
      move: { ...this.state.move },
      lookDelta: { ...this.state.lookDelta },
      defuseHold: this.state.defuseHold,
      check: this.checkEdge,
      pause: this.pauseEdge,
      cameraToggle: this.cameraToggleEdge,
    }

    this.state.lookDelta = { x: 0, y: 0 }
    this.state.pause = false
    this.state.cameraToggle = false
    this.state.check = false
    return frame
  }

  dispose(): void {
    this.setEnabled(false)
  }
}
